import { apiFetch } from './client';
import type { CommandIntent } from './commands';

export interface ConversationSummary {
  id: string;
  title: string;
  updated_at: string;
}

export interface ConversationMessage {
  id: string;
  user_message: string;
  assistant_reply: string;
  error_code?: string;
  navigation_path?: string;
  proposed_intents: CommandIntent[];
  created_at: string;
}

export interface ConversationDetail {
  id: string;
  title: string;
  messages: ConversationMessage[];
}

export async function listConversations(
  token: string | null,
  slug: string,
): Promise<ConversationSummary[]> {
  return apiFetch<ConversationSummary[]>(
    `/api/v1/organizations/${encodeURIComponent(slug)}/ai/conversations`,
    { token },
  );
}

export async function getConversation(
  token: string | null,
  slug: string,
  id: string,
): Promise<ConversationDetail> {
  return apiFetch<ConversationDetail>(
    `/api/v1/organizations/${encodeURIComponent(slug)}/ai/conversations/${encodeURIComponent(id)}`,
    { token },
  );
}

export async function deleteConversation(
  token: string | null,
  slug: string,
  id: string,
): Promise<void> {
  await apiFetch<void>(
    `/api/v1/organizations/${encodeURIComponent(slug)}/ai/conversations/${encodeURIComponent(id)}`,
    { method: 'DELETE', token },
  );
}
